import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useTheme } from '../hooks/useTheme';

interface ThemeToggleProps {
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { isDark, toggle } = useTheme();

  return (
    <motion.button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`relative w-11 h-11 rounded-full flex items-center justify-center overflow-hidden
        bg-white/70 dark:bg-white/10 backdrop-blur-md border border-gray-200 dark:border-white/15
        shadow-lg shadow-primary/10 dark:shadow-primary/20 hover:shadow-primary/30
        transition-colors duration-300 group ${className}`}
      whileHover={{ scale: 1.08, rotate: isDark ? -12 : 12 }}
      whileTap={{ scale: 0.9 }}
    >
      <span
        className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, rgba(108,99,255,0.25) 0%, transparent 70%)',
        }}
      />
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={isDark ? 'sun' : 'moon'}
          initial={{ rotate: -90, opacity: 0, scale: 0.4 }}
          animate={{ rotate: 0, opacity: 1, scale: 1 }}
          exit={{ rotate: 90, opacity: 0, scale: 0.4 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className="relative z-10"
        >
          {isDark ? (
            <FaSun className="text-amber-300 text-lg drop-shadow-[0_0_8px_rgba(252,211,77,0.9)]" />
          ) : (
            <FaMoon className="text-primary text-lg drop-shadow-[0_0_6px_rgba(108,99,255,0.8)]" />
          )}
        </motion.span>
      </AnimatePresence>
    </motion.button>
  );
};

export default ThemeToggle;
